import { UndoOutlined } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AskAnotherQuestion from './AskAnotherQuestion';
import AskAnotherQuestionButton from './AskAnotherQuestionButton';
import AskAnotherQuestionWrapper from './AskAnotherQuestionWrapper';

interface StartNewFreshChatInputProps {
  onAskNewQuestion?: () => void;
}

const StartNewFreshChatInput = function ({
  onAskNewQuestion,
}: StartNewFreshChatInputProps) {
  const { t } = useTranslation();

  return (
    <AskAnotherQuestionWrapper aria-label={t('askAnotherQuestion')}>
      <AskAnotherQuestionButton onClick={onAskNewQuestion} tabIndex={0}>
        <AskAnotherQuestion>
          {t('askAnotherQuestion')} <UndoOutlined aria-hidden="true" />
        </AskAnotherQuestion>
      </AskAnotherQuestionButton>
    </AskAnotherQuestionWrapper>
  );
};

export default StartNewFreshChatInput;
